
import { fetch as fetchPolyfill } from 'whatwg-fetch';

import { loadWidget } from '../utils/load-widget';

loadWidget('orchestra-ensemble', {
    props: [
        'defaultView',
        'peopleFeed',
        'instrumentsFeed',
    ],
    data: () => ({
        ViewModel: {
            View: "",
            Letter: false,
            Loading: true,
            Instruments: [],
            People: [],
        },

    }),
    methods: {
        init() {
            this.ViewModel.View = this.defaultView;

            this.getData().then(data => {
                this.ViewModel.Instruments = data.instruments;
                this.ViewModel.People = data.people;
            }).finally(() => {
                this.ViewModel.Loading = false;
            });
        },

        toggleInstrument(instrument) {
            instrument.Open = !instrument.Open;
            this.$forceUpdate();
        },

        getPeopleForInstrument(ViewModel, instrumentTitle) {
            let people = [];
            for (let person of ViewModel.People) {
                if (person.Instrument === instrumentTitle) {
                    people.push(person);
                }
            }
            return people;
        },

        setView(ViewModel, data) {
            ViewModel.View = data;
        },

        getPeopleForAlpha(ViewModel, alpha) {
            let people = [];
            for (let person of ViewModel.People) {
                if (person.Alpha === alpha) {
                    people.push(person);
                }
            }
            return people;
        },

        setAlpha(ViewModel, letter) {
            if (ViewModel.Letter === letter) {
                ViewModel.Letter = false;
            } else {
                ViewModel.Letter = letter;
            }
        },

        getAlpha(ViewModel, ignoreLetter) {
            if (ViewModel.Letter && !ignoreLetter) {
                return ViewModel.Letter;
            }

            return ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z"];
        },

        getCloudinarySrc(image, height, width) {
            return image.replace(/h_\d+/, `h_${height}`).replace(/w_\d+/, `w_${width}`);
        },

        getData() {
            const fetchConfig = {headers: {}};

            // // Grabs the auth details from the URL
            // const auth = feedURL.match(/:\/\/([^@]+)@/);
            // if (auth) {
            //     fetchConfig['headers']['Authorization'] = `Basic ${btoa(auth[1])}`;
            // }

            const promises = [
                fetchPolyfill(this.peopleFeed, fetchConfig).then(response => response.json()),
                fetchPolyfill(this.instrumentsFeed, fetchConfig).then(response => response.json()),
            ];
            return Promise.all(promises).then(data => {
                return {
                    people: data[0],
                    instruments: data[1],
                };
            });
        }
    },
    beforeMount() {
        this.init();
    }
});